import swrUpload from '@/services/api/swrUpload';
import csvTypes from '@/constants/csvTypes';

export default {
    namespaced: true,
    state: {
        executeLoader: false,
        counters: null
    },
    getters: {
        getExecuteLoader: (state) => state.executeLoader,
        getCounters: (state) => state.counters
    },
    mutations: {
        setExecuteLoader (state, payload) {
            state.executeLoader = payload;
        },
        setCounters (state, payload) {
            state.counters = payload;
        }
    },
    actions: {
        verifyFile (context, data) {
            const dispatchName = {
                [csvTypes.BUBBLE_WAREHOUSES]: 'verifyWarehouseFile',
                [csvTypes.WAREHOUSE_FAMILIES]: 'verifyFamiliesFile',
                [csvTypes.BUBBLES]: 'verifyBubblesFile'
            };
            if (Object.prototype.hasOwnProperty.call(dispatchName, data.type)) {
                return context.dispatch(dispatchName[data.type], data.file);
            }
        },
        executeFile (context, data) {
            const dispatchName = {
                [csvTypes.BUBBLE_WAREHOUSES]: 'executeWarehouseFile',
                [csvTypes.WAREHOUSE_FAMILIES]: 'executeFamiliesFile',
                [csvTypes.BUBBLES]: 'executeBubblesFile'
            };
            if (Object.prototype.hasOwnProperty.call(dispatchName, data.type)) {
                context.commit('setExecuteLoader', true);
                return context.dispatch(dispatchName[data.type], data.file).finally(() => {
                    context.commit('setExecuteLoader', false);
                });
            }
        },
        fileToFormData (context, file) {
            const formData = new FormData();
            formData.append('family_choice_path_import_file', file);
            return formData;
        },
        verifyWarehouseFile (context, file) {
            return context.dispatch('fileToFormData', file).then((data) => {
                return swrUpload.verifyWarehouseFile(data);
            });
        },
        executeWarehouseFile (context, file) {
            return context.dispatch('fileToFormData', file).then((data) => {
                return swrUpload.executeWarehouseFile(data);
            });
        },
        verifyFamiliesFile (context, file) {
            return context.dispatch('fileToFormData', file).then((data) => {
                return swrUpload.verifyFamiliesFile(data);
            });
        },
        executeFamiliesFile (context, file) {
            return context.dispatch('fileToFormData', file).then((data) => {
                return swrUpload.executeFamiliesFile(data);
            });
        },
        verifyBubblesFile (context, file) {
            return context.dispatch('fileToFormData', file).then((data) => {
                return swrUpload.verifyBubblesFile(data);
            });
        },
        executeBubblesFile (context, file) {
            return context.dispatch('fileToFormData', file).then((data) => {
                return swrUpload.executeBubblesFile(data);
            });
        },
        getCounters (context) {
            context.commit('setCounters', null);
            return swrUpload.getCounters().then(({ data }) => {
                context.commit('setCounters', data.data);
            });
        },
        getCurrentBubbles () {
            return swrUpload.getCurrentBubbles();
        },
        getCurrentBubbleWarehouses () {
            return swrUpload.getCurrentBubbleWarehouses();
        },
        getCurrentWarehouseFamilies () {
            return swrUpload.getCurrentWarehouseFamilies();
        }
    }
};
